module.exports = __webpack_public_path__ + "assets/montserrat-semibold.537e9277abaf4e89f9d46167ae2e43be94c01965adbab02baf143bce1fd1b3e6.woff";